module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_plekan_list animated active"
  }, [_c('span', {
    staticClass: "_plekan_list_title"
  }, [_vm._v("Component List")]), _vm._v(" "), _c('button', {
    staticClass: "plekan-open-module-list",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openModuleList
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "plekan-module-sortable-list"
    }
  }, _vm._l((_vm.list), function(l, key) {
    return _c('span', {
      staticClass: "plekan-list-item",
      attrs: {
        "href": "#",
        "data-index": key
      }
    }, [_c('img', {
      staticClass: "plekan-move-row",
      attrs: {
        "src": _vm.$plekanutils.makeUrl(l.thumbnail, _vm.$thumbnailPath)
      }
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4559edcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list.vue
// module id = 112
// module chunks = 0